document.addEventListener("DOMContentLoaded", () => {
    const checkboxes = document.querySelectorAll(".sector-checkbox");
  
    checkboxes.forEach(cb => {
      cb.addEventListener("change", () => {
        let selected = [];
        checkboxes.forEach(c => {
          if (c.checked) selected.push(c.value);
        });

        console.log(selected)
  
        // Shopify expects tags appended after collection handle
        let filterQuery = selected.length ? "/" + selected.join("+") : "";
        let url;
        if (filterQuery) {
            url = `/collections${filterQuery}?section_id=main-collection`;
        } else {
            url = `/collections/all?section_id=main-collection`;
        }
        
        console.log(url)

  
        fetch(url)
          .then(res => res.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, "text/html");
            const newGrid = doc.querySelector("#product-grid");
            console.log(newGrid)
            if (newGrid) {
              document.querySelector("#product-grid").innerHTML = newGrid.innerHTML;
            }
          })
          .catch(err => console.error(err));
      });
    });
});
  